import { useQueryClient } from 'react-query';
import { queryKeys } from '../fax-queries';

export const useInvalidateFaxCount = () => {
  const queryClient = useQueryClient();
  return () => {
    const keys = [...queryKeys.base, 'count'];
    queryClient.invalidateQueries(keys);
  };
};
